"use strict";

Shopify.theme.jsSlideshowWithText = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsSlideshowWithText = $.extend(this, Shopify.theme.getSectionData($section));
    console.log("section"+$section);
    var textTransition = this.text_transition; // Selectors

    var $imageSlideshowEl, $textSlideshowEl, $imageSlideshow, $textSlideshow;

    var autoPlayTimer = this.image_slideshow_speed * 1000;

    function runFlickity() {
      $imageSlideshowEl = $section.find('[data-image-slideshow]').removeClass('is-hidden');
      $textSlideshowEl = $section.find('[data-text-slideshow]').removeClass('is-hidden');
      $imageSlideshow = $imageSlideshowEl.flickity({
        contain: true,
        wrapAround: true,
        prevNextButtons: true, // this.number_of_slides > 1 ? this.show_arrows : false,
        pageDots: false,
        draggable: true,
        imagesLoaded: true,
        fade: false, // this.image_transition == 'fade' ? true : false,
        autoPlay: autoPlayTimer
        // arrowShape: arrowShape
      });
      $textSlideshow = $textSlideshowEl.flickity({
        autoplay: false,
        contain: true,
        imagesLoaded: true,
        lazyload: 4,
        prevNextButtons: false,
        pageDots: true, // this.number_of_slides > 1 ? this.show_nav_buttons : false,
        draggable: false,
        on: {
          ready: function ready() {
            var $currentTextSlide = $textSlideshowEl.find('.is-selected .text-slideshow__content');
            Shopify.theme.animation.slideTransition($currentTextSlide, textTransition);
          }
        }
      });
    }
    runFlickity();
    console.log('!!!!1');
    if ($imageSlideshowEl[0].querySelector(':scope > .image-slideshow__slide') || $textSlideshowEl[0].querySelector(':scope > .text-slideshow__slide')) {
      $imageSlideshowEl.flickity('destroy');
      const newImageSlideshowEl = document.createElement('div');
      newImageSlideshowEl.className = 'image-slideshow';
      newImageSlideshowEl.setAttribute('data-image-slideshow', '');
      $imageSlideshowEl[0].insertAdjacentElement('afterend', newImageSlideshowEl);
      newImageSlideshowEl.innerHTML = $imageSlideshowEl[0].innerHTML;
      console.log(newImageSlideshowEl.innerHTML);;
      $imageSlideshowEl.remove();

      $textSlideshowEl.flickity('destroy');
      const newtextSlideshowEl = document.createElement('div');
      newtextSlideshowEl.className = 'text-slideshow';
      newtextSlideshowEl.setAttribute('data-text-slideshow', '');
      $textSlideshowEl[0].insertAdjacentElement('afterend', newtextSlideshowEl);
      newtextSlideshowEl.innerHTML = $textSlideshowEl[0].innerHTML;
      $textSlideshowEl.remove();
      runFlickity();
    }

    $imageSlideshow.on('change.flickity', function (event, index) {
      $textSlideshow.flickity('select', index, true, true);
      var $currentTextSlide = $textSlideshowEl.find('.is-selected .text-slideshow__content');
      Shopify.theme.animation.slideTransition($currentTextSlide, textTransition);
    });
    $textSlideshow.on('change.flickity', function (event, index) {
      $imageSlideshow.flickity('select', index, true, false);
    });
    $section.find('.flickity-button').wrapAll('<div class="flickity-buttons-container"></div>');
  },
  blockSelect: function blockSelect($section, blockId) {
    var $slider = $section.find('[data-image-slideshow]');
    var $sliderIndex = $('#shopify-section-' + blockId).data('slide-index');
    $slider.flickity('select', $sliderIndex, true, true); // Fix for theme editor delay when adding new images to slideshow

    setTimeout(function () {
      $slider.flickity('resize');
    }, 500);
  },
  unload: function unload($section) {
    $section.find('.flickity-button').unwrap();
  }
};